import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface IConfirmationInput {
  title: string;
  text: string;
  /** Optional second paragraph, shown in red under the main text. */
  warningText?: string;
  confirmBtnText?: string;
  confirmBtnClass?: string;
  cancelBtnText?: string;
  cancelBtnClass?: string;
  reverseBtn?: boolean;
  /**
   * When set, the dialog shows a mandatory reason field. Confirm stays
   * disabled until a non-blank reason is entered, and the dialog closes with
   * the trimmed reason string instead of `true`.
   */
  reasonLabel?: string;
  /**
   * Max characters for the reason. Typing stops at the limit and the
   * remaining count is shown under the field.
   */
  reasonMaxLength?: number;
}

@Component({
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent {
  public reason = '';

  public get confirmBtnText(): string {
    return this.data.confirmBtnText ?? 'Ok';
  }
  public get confirmBtnClass(): string {
    return this.data.confirmBtnClass ?? 'mat-accent-200-bg';
  }

  public get cancelBtnText(): string {
    return this.data.cancelBtnText ?? 'Cancel';
  }
  public get cancelBtnClass(): string {
    return this.data.cancelBtnClass ?? 'mat-grey-200-bg';
  }

  public get requiresReason(): boolean {
    return !!this.data.reasonLabel;
  }

  public get reasonMaxLength(): number | null {
    return this.data.reasonMaxLength ?? null;
  }

  public get reasonCharsRemaining(): number | null {
    if (this.reasonMaxLength === null) {
      return null;
    }
    return Math.max(this.reasonMaxLength - this.reason.length, 0);
  }

  public get isReasonValid(): boolean {
    const trimmed = this.reason.trim();
    return (
      trimmed.length > 0 &&
      (this.reasonMaxLength === null || trimmed.length <= this.reasonMaxLength)
    );
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IConfirmationInput,
    private dialogRef: MatDialogRef<ConfirmDialogComponent>
  ) { }

  public confirmWithReason(): void {
    if (!this.isReasonValid) {
      return;
    }
    this.dialogRef.close(this.reason.trim());
  }
}
